import React from 'react';

interface UploadingTileProps {
  status: 'uploading' | 'processing' | 'failed' | 'completed';
  progress?: number;
  aspectRatio?: string;
}

const UploadingTile: React.FC<UploadingTileProps> = ({
  status,
  progress,
  aspectRatio = "16/9"
}) => {
  return (
    <div
      className="rounded-xl overflow-hidden relative"
      style={{ 
        aspectRatio,
        background: 'linear-gradient(135deg, #4a5568 0%, #2d3748 100%)'
      }}
    >
      <div className="w-full h-full flex items-center justify-center relative">
        {/* Morphing blob animations */}
        <div className="absolute shimmer-morph morph-1" aria-hidden="true"></div>
        <div className="absolute shimmer-morph morph-2" aria-hidden="true"></div>
        <div className="absolute shimmer-morph morph-3" aria-hidden="true"></div>
        <div className="absolute shimmer-morph morph-4" aria-hidden="true"></div>
        <div className="absolute shimmer-morph morph-5" aria-hidden="true"></div>
        <div className="absolute shimmer-morph morph-6" aria-hidden="true"></div>
        
        {/* Content */}
        <div className="relative z-10 text-center">
          {status === 'uploading' && (
            <div className="text-xl font-semibold text-white">
              {progress ? `${progress}%` : 'Uploading'}
            </div>
          )}
          {status === 'processing' && (
            <div className="text-xl font-semibold text-white">
              {progress ? `${progress}%` : 'Processing'}
            </div>
          )}
          {status === 'completed' && (
            <div className="text-xl font-semibold text-green-400">
              Completed
            </div>
          )}
          {status === 'failed' && (
            <div className="text-xl font-semibold text-red-400">
              Failed
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadingTile;
